import { useCallbackWithoutArguments } from "client/Hooks";
import { ReactElement, useState } from "react";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import { IconButtonLike } from "../IconButton/IconButtonLike";
import styles from "./IconButtonWithTitle.module.less";
import { FontIconName } from "../Icon/Icon";

export type IconButtonWithTitleProps = {
	title: string;
	icon: FontIconName;
	onClick: () => void;
	isDisabled?: boolean;
	trackingId: string;
};

export const IconButtonWithTitle = (props: IconButtonWithTitleProps): ReactElement => {
	const {
		title,
		icon,
		onClick: onClickFromProps,
		isDisabled = false,
		trackingId
	} = props;

	const [isHovered, setIsHovered] = useState<boolean>(false);

	const onClick: () => void = useCallbackWithoutArguments(onClickFromProps);

	return (
		<ButtonBase
			trackingId={trackingId}
			className={styles.root}
			onClick={onClick}
			disabled={isDisabled}
			onMouseEnter={() => setIsHovered(true)}
			onMouseLeave={() => setIsHovered(false)}
		>
			<IconButtonLike
				icon={icon}
				kind="secondary"
				shape="round"
				trackingId="icon-button"
				isDisabled={isDisabled}
				isActive={isHovered}
			/>

			<h4 className={styles.text}>
				{title}
			</h4>
		</ButtonBase>
	);
};
IconButtonWithTitle.displayName = "IconButtonWithTitle";